import { multiselect_options } from '../Constants';

export default class FirmwareManagement {
    constructor() {
        $('#hardware').multiselect(multiselect_options);
        $('#operator').multiselect(multiselect_options);
    };
};